import { IModel, IAttribute, Collection } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';

import { Owned } from 'app/model/base/named';
import { LinkedService } from '../linkedservice/linkedservice';
import { ParameterValue } from 'shell-models-lib';

@Metamodel.model({
    name: 'staging-setting'
})
export class StagingSettings extends Owned {
    public static readonly PATH: IAttribute;
    public static readonly ENABLE_COMPRESSION: IAttribute;
    public static readonly LINKED_SERVICE_PARAMETERS: IAttribute;
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        reference: true,
        type: LinkedService.MODEL
    })
    public storageLinkedService?: LinkedService;

    /**
     * Parameter value for referenced linked service.
     */
    @Metamodel.attribute({
        collection: Collection.Array,
        constraint: {
            required: false
        },
        association: 'LINKED_SERVICE_PARAMETERS'
    })
    public linkedServiceParameters: ParameterValue[] = [];

    @Metamodel.attribute({
        display: stringResources.StagingSetting_PathLabel,
        templatable: true,
        association: 'PATH'
    })
    public path?: string;

    @Metamodel.attribute({
        display: stringResources.StagingSetting_EnableCompressionLabel,
        templatable: true,
        association: 'ENABLE_COMPRESSION'
    })
    public enableCompression?: boolean;
}
